import { useTranslation } from '@exam-room/translations';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import { Button, Card } from '../../../components';
import { PATHS } from '../../../routes';
import { ExamGuidelines } from '../../exam/instruction/components';

import { ExamDetails } from './containers';

export function Instruction() {
  const navigate = useNavigate();
  const { taskId } = useParams();

  const { t } = useTranslation();

  return (
    <div className='flex h-full w-full flex-col overflow-auto' data-exam-content>
      <div className='bg-grey-50 flex-grow p-6 text-center'>
        <Card className='mx-auto size-full h-fit max-w-6xl flex-col items-center gap-10'>
          <ExamDetails />
          <div className='flex w-full flex-col gap-6'>
            <ExamGuidelines />
            <Button
              className='mx-auto w-3xs flex-none'
              onClick={() => navigate(generatePath(PATHS.Preview.Root, { taskId }))}
            >
              {t('instruction.startExam')}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
}

const InstructionRoute = {
  path: PATHS.Exam.Instruction,
  element: <Instruction />,
};

export default InstructionRoute;
